import { AuxIcon } from "@blk/aladdin-react-components-es";
import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { analyticsCopilotWidgetsSectionId } from "../constants";
import { preview } from "common/constants";
import { useMaximizedWidgetMode } from "components/workspaces/hooks/use-current-dashboard";
import { language } from "language/default";
import { maximizeWidget, minimizeWidget } from "store/current-dashboard";
export const InsMaximizeIcon = ({ widgetId, sectionId, groupId, showMaximize }) => {
    const dispatch = useDispatch(), isMaximizedMode = useMaximizedWidgetMode(sectionId, groupId ?? widgetId);
    const onMaximizeClicked = useCallback(() => {
        const [mainApp] = document.getElementsByClassName("aux-app-frame__main");
        if (!sectionId || !widgetId) {
            return;
        }
        isMaximizedMode
            ? dispatch(minimizeWidget())
            : dispatch(maximizeWidget({ scrollPositionBeforeMaximizing: mainApp.scrollTop, sectionId, widgetId: groupId ?? widgetId }));
    }, [dispatch, isMaximizedMode, sectionId, widgetId, groupId]);
    if (!sectionId || !widgetId || !showMaximize || sectionId === preview.sectionId || sectionId === analyticsCopilotWidgetsSectionId) {
        return React.createElement(React.Fragment, null);
    }
    return React.createElement("div", { className: "widgetButtonHeader pdf-expand", title: isMaximizedMode ? language.en.widget.minimize : language.en.widget.maximize },
        React.createElement(AuxIcon, { slot: "target", state: "secondary", type: isMaximizedMode ? "widget-minimize" : "widget-maximize", onClick: onMaximizeClicked }));
};
